/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClientTenantsResponseDto } from './ClientTenantsResponseDto';
export type ClientUpdateResponseDto = {
  /**
   * User id from Cognito.
   */
  cognitoUserId: string;
  /**
   * Client phone number including country code.
   */
  phoneNumber: string;
  /**
   * Locale preferred by the client.
   */
  locale: ClientUpdateResponseDto.locale;
  /**
   * Current status of the client.
   */
  status: ClientUpdateResponseDto.status;
  /**
   * List of tenants this client belongs to.
   */
  tenants: Array<ClientTenantsResponseDto>;
  /**
   * Timestamp when the client registered.
   */
  registeredAt: string;
  /**
   * Timestamp when the client was activated.
   */
  activatedAt?: string;
  /**
   * Timestamp when the client was deactivated.
   */
  deactivatedAt?: string;
  /**
   * Timestamp when the client was last suspended.
   */
  lastSuspendedAt?: string;
  /**
   * Timestamp when the client was onboarded.
   */
  onboardedAt?: string;
  /**
   * Timestamp when the client accepted the legal documents.
   */
  legalDocAcceptedAt?: string;
  targetStatus?: ClientUpdateResponseDto.targetStatus;
};
export namespace ClientUpdateResponseDto {
  /**
   * Locale preferred by the client.
   */
  export enum locale {
    EN = 'EN',
    LV = 'LV',
    NO = 'NO',
    FI = 'FI',
  }
  /**
   * Current status of the client.
   */
  export enum status {
    ACTIVE = 'ACTIVE',
    ACTIVATION_IN_PROGRESS = 'ACTIVATION_IN_PROGRESS',
    PENDING = 'PENDING',
    PENDING_IN_PROGRESS = 'PENDING_IN_PROGRESS',
    SUSPENDED = 'SUSPENDED',
    SUSPEND_IN_PROGRESS = 'SUSPEND_IN_PROGRESS',
    DEACTIVATED = 'DEACTIVATED',
    DEACTIVATE_IN_PROGRESS = 'DEACTIVATE_IN_PROGRESS',
    RESET = 'RESET',
    RESET_IN_PROGRESS = 'RESET_IN_PROGRESS',
  }
  export enum targetStatus {
    ACTIVE = 'ACTIVE',
    ACTIVATION_IN_PROGRESS = 'ACTIVATION_IN_PROGRESS',
    PENDING = 'PENDING',
    PENDING_IN_PROGRESS = 'PENDING_IN_PROGRESS',
    SUSPENDED = 'SUSPENDED',
    SUSPEND_IN_PROGRESS = 'SUSPEND_IN_PROGRESS',
    DEACTIVATED = 'DEACTIVATED',
    DEACTIVATE_IN_PROGRESS = 'DEACTIVATE_IN_PROGRESS',
    RESET = 'RESET',
    RESET_IN_PROGRESS = 'RESET_IN_PROGRESS',
  }
}

